module.exports = __webpack_public_path__ + "static/media/in_point_charge.bac52b72.svg";